import { gql } from 'urql'

const QueryUserPermissionsList = gql`
  query ($userId: Int, $roleId: Int, $roleKind: RoleKind, $userKind: UTenantKind) {
    userPermissionsList(
      userId: $userId
      roleId: $roleId
      roleKind: $roleKind
      userKind: $userKind
    ) {
      collection {
        id
        visibility
        moduleName
        kind
        toggleable
        enabled
        objects
        objectMapping
        fieldPermissionsStats
      }
    }
  }
`

export default QueryUserPermissionsList
